import React from 'react';
import $ from 'jquery';

class JobTool extends React.Component {
  constructor() {
    super();
    this.state = {
      allJobs: [],
      jobs: [],
      filterSelection1: '',
      filterSelection2: ''
    };

    this.onFilterSelection1Change = this.onFilterSelection1Change.bind(this);
    this.onFilterSelection2Change = this.onFilterSelection2Change.bind(this);
  }

  componentDidMount() {
    $.ajax({
      url: '/api/v2/jobs',
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null && data.jobs && data.jobs.length) {
          this.setState({ allJobs: data.jobs, jobs: data.jobs });
        }
      },
      error: (xhr, status, err) => console.error(status, err.toString())
    });
  }

  onFilterSelection1Change(event) {
    const { allJobs, filterSelected2 } = this.state;
    const selectedValue = event.target.value;
    let filteredJobs = allJobs;

    if (filterSelected2 && filterSelected2.length) {
      filteredJobs = filteredJobs.filter((job) => job.selection2 === filterSelected2);
    }

    if (selectedValue && selectedValue.length) {
      filteredJobs = filteredJobs.filter((job) => job.selection1 === selectedValue);
    }

    this.setState({ jobs: filteredJobs, filterSelected1: selectedValue });
  }

  onFilterSelection2Change(event) {
    const { allJobs, filterSelected1 } = this.state;
    const selectedValue = event.target.value;
    let filteredJobs = allJobs;

    if (selectedValue && selectedValue.length) {
      filteredJobs = filteredJobs.filter((job) => job.selection2 === selectedValue);
    }

    if (filterSelected1 && filterSelected1.length) {
      filteredJobs = filteredJobs.filter((job) => job.selection1 === filterSelected1);
    }

    this.setState({ jobs: filteredJobs, filterSelected2: selectedValue });
  }

  render() {
    const { jobs, allJobs } = this.state;
    const jobsSelection1 = allJobs.map((job) => job.selection1).sort();
    const jobsSelection2 = allJobs.map((job) => job.selection2);

    return (
      <div>
        <label htmlFor="job-filter-selection1">Bitte wählen Sie einen Anstellungsort aus:</label>
        <select
          id="job-filter-selection1"
          className="index-filter-select"
          onChange={this.onFilterSelection1Change}
        >
          <option value="">Alle</option>
          {jobsSelection1
            .filter((jobSelection1, index) => jobsSelection1.indexOf(jobSelection1) === index)
            .map((jobSelection1, index) => (
              <option key={`job-filter-selection1-${index}`} value={jobSelection1}>
                {jobSelection1}
              </option>
            ))}
        </select>
        <label htmlFor="job-filter-selection2">Bitte wählen Sie ein Unternehmen aus:</label>
        <select
          id="job-filter-selection2"
          className="index-filter-select"
          onChange={this.onFilterSelection2Change}
        >
          <option value="">Alle</option>
          {jobsSelection2
            .filter((jobSelection2, index) => jobsSelection2.indexOf(jobSelection2) === index)
            .map((jobSelection2, index) => (
              <option key={`job-filter-selection2-${index}`} value={jobSelection2}>
                {jobSelection2}
              </option>
            ))}
        </select>
        <div className="job-tool-wrapper" style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%' }} cellSpacing="1" cellPadding="1">
            <thead>
              <tr>
                <th>Positionsname</th>
                <th>Anstellungsort</th>
                <th>Unternehmen</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {jobs.map((job, index) => {
                return (
                  <tr key={`job-${index}`}>
                    <td>
                      <a href={job.url} title={`Detailansicht zu ${job.title}`} target="_blank">
                        {job.title}
                      </a>
                    </td>
                    <td>{job.selection1}</td>
                    <td>{job.selection2}</td>
                    <td>
                      <a href={job.url} title={`Detailansicht zu ${job.title}`} target="_blank">
                        Details
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default JobTool;



// WEBPACK FOOTER //
// ./components/JobTool.js